<template lang="html">
    <div class="table-wrap monthly-mean-flow-table">

        <scrolling-table class="scroll-table" :data="scrollingTableData" />

        <div class="footnotes">
            <p>* Incomplete and Unverified Data</p>
            <p>(n) Incomplete month. Number of days used in average.</p>
        </div>
    </div>
</template>

<script>
import streamflowData from '@/mixins/streamflowData';
import ScrollingTable from '@/components/ScrollingTable';
import * as d3 from 'd3';

export default {
    name: 'monthly-mean-flow-table',
    mixins: [streamflowData],
    components: {
        ScrollingTable,
    },
    methods: {
        getColor(item, max, min) {
            if (item.full_month === false) {
                return 'rgb(230,230,230)';
            }
            const val = item.value;
            // Define the colors
            const low = [245, 252, 255];
            const high = [111, 145, 164];
            const result = [255, 255, 255];

            // Check if a value is the same as max
            if (val === max) {
                return `rgb(${high[0]}, ${high[1]}, ${high[2]})`;
            }

            // Check if the value is the same as min
            if (val === min) {
                return `rgb(${low[0]}, ${low[1]}, ${low[2]})`;
            }

            // Calculate the color for the value
            for (let i = 0; i < result.length; i++) { // eslint-disable-line no-plusplus
                result[i] = Math.round(low[i] + ((val - min) * ((high[i] - low[i]) / (max - min))));
            }

            // Return the result
            return `rgb(${result[0]}, ${result[1]}, ${result[2]})`;
        },
    },
    computed: {
        scrollingTableData() {
            const tableData = this.tableData || [];

            if (this.tableData.length === 0) {
                return [];
            }

            // check if the tableData array is formatted, but still all null values
            if (this.tableData.length === 4) { // header, min, max, mean
                let emptyTable = true;
                for (let rowNum = 1; rowNum < 4; rowNum += 1) {
                    const row = this.tableData[rowNum];
                    // check cell value, skipping first (label) column
                    if (row.some((cell, colNum) => cell.value !== null && colNum > 0)) {
                        emptyTable = false;
                        break;
                    }
                }

                if (emptyTable) {
                    return [];
                }
            }

            // colorize cells
            for (let r = 1, numRows = tableData.length; r < numRows; r += 1) {
                const row = tableData[r];
                const vals = row.slice(1).map(e => e.value);
                const min = d3.min(vals);
                const max = d3.max(vals);
                row.forEach((col, c) => {
                    if (c === 0) return;
                    const color = this.getColor(col, max, min);
                    tableData[r][c].color = color;
                });
            }

            return tableData;
        },
    },
};
</script>

<style lang="scss">
.monthly-mean-flow-table.table-wrap {
    overflow: auto;

    .scroll-table {
        height: calc(100vh - 220px);
    }

    div.footnotes > p {
        margin-top: 8px;
        padding-left: 16px;
        font-size: 12px;
        font-style: oblique;
        margin-bottom: 8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/charts/MonthlyMeanFlowTable.vue